module.exports = __webpack_public_path__ + "img/folder.59051cf6.svg";